import React from "react";
import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";

import AddOrganizationForm from "../../components/auth/AddOrganizationForm";
const AddOrganization2 = () => {
  return (
    <AuthLayout>
      <div className="  flex flex-col gap-8 px-12 ">
        <div className="flex flex-col gap-5 text-center">
          <PageTitle title="Add New Court" />
          <p className="text-lg font-normal leading-[22.68px] text-[#1E1850] mt-1">
            Lorem ipsum dolor sit amet consectetur
          </p>
        </div>

        <AddOrganizationForm />
      </div>
    </AuthLayout>
  );
};

export default AddOrganization2;
